import { InjectionToken } from '@angular/core';
import { IQrCodeService } from './qr-code-service.interface';

export const QR_CODE_SERVICE = new InjectionToken<IQrCodeService>(
  'QR_CODE_SERVICE'
);
